// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3HXte","title":"styles_title__36L-j","rateWrap":"styles_rateWrap__2IvOz"};